import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { Form, Icon, Input, Button, Col } from 'antd';
import InputHelper from '../../helper/form/input';
const FormItem = Form.Item;

export class Register extends Component {

  constructor(props) {
    super(props)
    this.state = {
      dateOfBirth: '',
      email: '',
      firstName: '',
      lastName: '',
      password: '',
      phoneNumber: '',
      passwordConfirmed: '',
      check: false
    }

    this.check = {};
  }

  static propTypes = {
    authentification: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  handleChangeBirthday = (date, dateString) => {
    this.setState({
      dateOfBirth: date,
    });
  }

  onCheck = (name, value) => {
    this.check[name] = value;

    const keys = Object.keys(this.check);
    const lengthOfForm = 6;

    if (keys.length === lengthOfForm && keys.filter(k => this.check[k]).length === lengthOfForm)
      this.setState({ check: true })
  }

  handleSubmit = () => {
    if (!this.props.authentification.status.register.pending && this.state.check) {
      let user = this.state;
      user.phoneNumber = user.phoneNumber.toString();
      this.props.actions.register(user);
    }
  }

  render() {
    return (
        <Form className="authentification-register login-form form-front">
            <FormItem>
              <InputHelper.Item
                icon="user"
                value={this.state.firstName}
                isValid={(string) => string.length > 2}
                onCheck={(value) => this.onCheck('firstName', value)}
                status={{ success: '', error: 'Le prénom doit faire plus de trois caractères' }}
                onChange={(firstName) => this.setState({ firstName })}
                checkOnChange
                prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="Prénom" />
              <InputHelper.Item
                icon="user"
                value={this.state.lastName}
                onCheck={(value) => this.onCheck('lastName', value)}
                isValid={(string) => string.length > 2}
                status={{ success: '', error: 'Le nom de famille doit faire plus de trois caractères' }}
                onChange={(lastName) => this.setState({ lastName })}
                prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="Nom"
                checkOnChange />
              <InputHelper.Email
                required
                value={this.state.email}
                onCheck={(value) => this.onCheck('email', value)}
                onChange={(email) => this.setState({ email })}
                prefix={<Icon type="mail" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="Email" />
            </FormItem>
            <FormItem>
              <InputHelper.Password
                value={this.state.password}
                onCheck={(value) => this.onCheck('password', value)}
                onChange={(password) => this.setState({ password })}
                checkOnChange
                required
                prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder="Mot de passe" />
              <InputHelper.Password
                setStatus={this.state.password !== '' && this.state.passwordConfirmed === this.state.password ? 'success' : 'error'}
                status={{ success: '', error: 'Le mot de passe doit être identique' }}
                onCheck={(value) => this.onCheck('passwordConfirmed', value)}
                checkOnChange
                required
                value={this.state.passwordConfirmed}
                onChange={(passwordConfirmed) => this.setState({ passwordConfirmed })}
                prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder="Mot de passe" />
            </FormItem>
            <FormItem>
              <InputHelper.DateOfBirth
                value={this.state.dateOfBirth}
                required
                onChange={this.handleChangeBirthday}
                prefix={<Icon type="phone" style={{ color: 'rgba(0,0,0,.25)' }} />}
              />
            </FormItem>
            <FormItem>
              <InputHelper.Phone
                onCheck={(value) => this.onCheck('phoneNumber', value)}
                required
                value={this.state.phoneNumber}
                onChange={(phoneNumber) => this.setState({ phoneNumber })} />
            </FormItem>
            <p style={{textAlign:'right'}}>Les inscriptions sont soumises aux mentions relatives au <a href="https://privacy.ynov.com/" target_blank style={{fontWeight:'bold', color:'#23b2a4'}}>RGPD</a></p>
            <FormItem>
              <Button
                onClick={this.handleSubmit}
                disabled={!this.state.check}
                htmlType="submit"
                className="ant-btn ui-btn">
                S'inscrire
                    </Button>
            </FormItem>
          </Form>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    authentification: state.authentification,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Register);



// WEBPACK FOOTER //
// ./src/features/authentification/Register.js